import { useParams } from 'react-router-dom';
import { iframeOnLoadHelper } from '../../../helper/iframeOnLoadHelper';
import { ELDA_URL } from '../../../variables';
import Terms from '../../components/common/Terms';

const ApiDefPage = () => {

    const params = useParams();

    let src = '';

    let def = params ? params["*"] : undefined;

    if(!def || def === "undefined"){
        src = `${ELDA_URL}/def`
    } else {
        src = `${ELDA_URL}/def/${def}`
    }

    if(src.endsWith("/")){
        src = src.slice(0, -1);
    }
    

    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <iframe
                title="ApiDefPage"
                src={src}
                style={{ width: '100%', height: 'calc(100vh - 95px)' }}
                onLoad={iframeOnLoadHelper}
            />
            <Terms />
        </div>
    );
};

export default ApiDefPage;
